const COUNTRIES = {
  USA: 'United States of America',
  CANADA: 'Canada',
  AUSTRALIA: 'Australia',
  NEW_ZEALAND: 'New Zealand',
  UK: 'U.K.',
};

export const STATES_BY_COUNTRY = {};

STATES_BY_COUNTRY[COUNTRIES.USA] = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'Armed Forces Americas',
  'Armed Forces Europe', 'Armed Forces Pacific', 'California',
  'Colorado', 'Connecticut', 'Delaware', 'District of Columbia',
  'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana',
  'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland',
  'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri',
  'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
  'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
  'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia',
  'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
];

STATES_BY_COUNTRY[COUNTRIES.CANADA] = [
  'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
  'Newfoundland and Labrador', 'Northwest Territories',
  'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island',
  'Quebec', 'Saskatchewan', 'Yukon',
];

STATES_BY_COUNTRY[COUNTRIES.AUSTRALIA] = [
  'New South Wales', 'Queensland', 'South Australia', 'Tasmania', 'Victoria', 'Western Australia',
];

export default COUNTRIES;
